import React from "react";
import { ContactFormHandler } from "./ContactFormHandler";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export const ContactSection: React.FC = () => {
  console.log('ContactSection component is rendering');
  
  return (
    <section id="contact" className="border-t bg-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <header className="mb-8">
          <h2 className="text-3xl font-semibold text-gray-900">Contact Us</h2>
          <p className="mt-2 text-gray-600">
            Tell us about your goals and we’ll get back to you shortly.
          </p>
        </header>

        <ContactFormHandler>
          {({ formData, setFormData, handleSubmit, loading, isSubmitted }) => (
            isSubmitted ? (
              <div className="rounded-lg bg-green-50 p-6 text-green-700">
                Thank you! Your message has been received. We’ll be in touch soon.
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700" htmlFor="name">Name</label>
                  <Input
                    id="name"
                    placeholder="Jane Doe"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    required
                  />
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700" htmlFor="email">Email</label>
                  <Input
                    id="email"
                    type="email"
                    placeholder="jane@company.com"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    required
                  />
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700" htmlFor="company">Company</label>
                  <Input
                    id="company"
                    placeholder="Acme Inc."
                    value={formData.company || ""}
                    onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                  />
                </div>

                <div className="space-y-2">
                  <label className="text-sm font-medium text-gray-700" htmlFor="phone">Phone</label>
                  <Input
                    id="phone"
                    placeholder="+44 20 1234 5678"
                    value={formData.phone || ""}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  />
                </div>

                <div className="md:col-span-2 space-y-2">
                  <label className="text-sm font-medium text-gray-700" htmlFor="subject">Subject</label>
                  <Input
                    id="subject"
                    placeholder="How can we help?"
                    value={formData.subject || ""}
                    onChange={(e) => setFormData({ ...formData, subject: e.target.value })}
                  />
                </div>

                <div className="md:col-span-2 space-y-2">
                  <label className="text-sm font-medium text-gray-700" htmlFor="message">Message</label>
                  <Textarea
                    id="message"
                    placeholder="Tell us a bit about your project or requirements..."
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    rows={6}
                    required
                  />
                </div>

                <div className="md:col-span-2 flex justify-end pt-2">
                  <Button 
                    type="submit" 
                    className="bg-gray-900 hover:bg-gray-800 text-white" 
                    disabled={loading}
                    onClick={() => console.log('Button clicked, form data:', formData)}
                  >
                    {loading ? "Sending..." : "Send Message"}
                  </Button>
                </div>
              </form>
            )
          )}
        </ContactFormHandler>
      </div>
    </section>
  );
};
